<script setup>
  import {ref} from "vue";

  import ComponentRecordEditLabelDialog from "@components/Dialogs/RecordEditLabelDialog.vue";
  import {MedLink, MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentRecordLabel",
  });

  const props = defineProps({
    record: {
      type: Object,
      required: true,
    },
  });

  const refEditRecordLabelDialog = ref(null);

  function openEditRecordLabel() {
    if (refEditRecordLabelDialog.value) {
      refEditRecordLabelDialog.value.open(props.record);
    }
  }
</script>

<template>
  <div class="leading-4 whitespace-nowrap">
    <MedTooltip v-if="record.label" content="Interne Bezeichnung" placement="bottom">
      <MedLink as="button" size="xs" :data-test="getTestId('record-label-button')" @click="openEditRecordLabel">
        {{ record.label }}
      </MedLink>
    </MedTooltip>
    <MedLink
      v-else
      as="button"
      size="xs"
      variant="primary"
      :data-test="getTestId('record-label-create-button')"
      @click="openEditRecordLabel"
    >
      Bezeichnung vergeben
    </MedLink>
  </div>
  <component-record-edit-label-dialog ref="refEditRecordLabelDialog" />
</template>
